import { render, staticRenderFns } from "./MultiStepFormInputQuestion.vue?vue&type=template&id=3cb4c715&scoped=true&"
import script from "./MultiStepFormInputQuestion.vue?vue&type=script&lang=js&"
export * from "./MultiStepFormInputQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepFormInputQuestion.vue?vue&type=style&index=0&id=3cb4c715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4c715",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VTextField})
